// Personalised welcome copy based on UTM + landing slug.

const SOURCE_LABEL = {
  instagram: "Instagram",
  insta: "Instagram",
  ig: "Instagram",
  facebook: "Facebook",
  fb: "Facebook",
  meta: "Meta",
  google: "Google",
  tiktok: "TikTok",
  youtube: "YouTube",
  yt: "YouTube",
  email: "onze nieuwsbrief",
  newsletter: "onze nieuwsbrief",
  partner: "een partner",
  knhs: "KNHS",
};

const PATH_AUDIENCE = {
  "/eigen-paard": "paardeneigenaar",
  "/premium": "premium ruiter",
  "/manege-ruiter": "manege ruiter",
  "/manege-module": "manege",
  "/fokkerij": "fokker",
  "/hoefsmid": "hoefsmid",
  "/paardentandarts": "paardentandarts",
  "/fysio-osteo": "fysio/osteo",
  "/trainer": "trainer",
  "/wedstrijdanalyse": "wedstrijdruiter",
  "/professional": "professional",
};

const CAMPAIGN_AUDIENCE = {
  ...PATH_AUDIENCE,
  eigenaar: "paardeneigenaar",
  premium: "premium ruiter",
  manege: "manege ruiter",
  fokker: "fokker",
  hoefsmid: "hoefsmid",
  tandarts: "paardentandarts",
  fysio: "fysio",
  osteo: "osteopaat",
  trainer: "trainer",
  wedstrijd: "wedstrijdruiter",
  pro: "professional",
  professional: "professional",
};

const norm = (v) => (typeof v === "string" ? v.toLowerCase().trim() : "");

export const deriveUtmCopy = ({ utm = {}, pathname = "/" } = {}) => {
  const source = norm(utm.utm_source);
  const campaign = norm(utm.utm_campaign);
  const medium = norm(utm.utm_medium);

  // Skip if no useful UTM info at all
  if (!source && !campaign && !medium) return null;

  const sourceLabel = SOURCE_LABEL[source] || (source ? cap(source) : null);
  const audience =
    CAMPAIGN_AUDIENCE[campaign] || PATH_AUDIENCE[pathname] || null;

  let title = "Welkom bij EquiSight";
  if (audience && sourceLabel) {
    title = `Welkom ${audience} — van ${sourceLabel}.`;
  } else if (audience) {
    title = `Welkom ${audience}.`;
  } else if (sourceLabel) {
    title = `Welkom — fijn dat je via ${sourceLabel} bent gekomen.`;
  }

  const offer =
    "Speciale launch-deal: 3 maanden Professional gratis voor de eerste Bèta testers.";

  return {
    title,
    offer,
    badge: sourceLabel ? `Via ${sourceLabel}` : "Launch deal",
  };
};

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
